import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { PushMessage } from "../../entity";

export class CreatePushMessageDTO {
  @Expose()
  @ValidateNested()
  @Type(() => PushMessage)
  pushMessage!: PushMessage;
}
